/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureTileOrderUpdate
 */
export interface FeatureTileOrderUpdate {
    /**
     * 
     * @type {string}
     * @memberof FeatureTileOrderUpdate
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof FeatureTileOrderUpdate
     */
    order: number;
}

/**
 * Check if a given object implements the FeatureTileOrderUpdate interface.
 */
export function instanceOfFeatureTileOrderUpdate(value: object): value is FeatureTileOrderUpdate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function FeatureTileOrderUpdateFromJSON(json: any): FeatureTileOrderUpdate {
    return FeatureTileOrderUpdateFromJSONTyped(json, false);
}

export function FeatureTileOrderUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureTileOrderUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'order': json['order'],
    };
}

export function FeatureTileOrderUpdateToJSON(json: any): FeatureTileOrderUpdate {
    return FeatureTileOrderUpdateToJSONTyped(json, false);
}

export function FeatureTileOrderUpdateToJSONTyped(value?: FeatureTileOrderUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'order': value['order'],
    };
}

